import { render, staticRenderFns } from "./Happytable.vue?vue&type=template&id=41e720c2"
import script from "./Happytable.vue?vue&type=script&lang=js"
export * from "./Happytable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports